// Copyright (c) 2017 Deere & Company

import DealerHierarchyFacet from '../../shared/state/dealer-hierarchy-facet';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateWipFacets = (state, action) =>
    DealerHierarchyFacet.update(state, {
        $set: action.facets
    });

export default (state = getDefaultState().wipFacets, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_WIP_FACETS]: updateWipFacets
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/wip-facets.js